export class MeterSysInfo {
    name: string;
    Product: string;
    SW: string;
    HW: string;
    XMSRCSWVER: string;
    configVersion: string;
    SN: string;
    WIFI: string;
    PlantType: string;
    imageName1: string;
    imageName2: string;
    MACAddr: string;
    Degraded: string;
    uptime: string;
}
